import { z } from 'zod';
import { emailSchema, idSchema } from './common.js';
import { permissionCodeSchema } from './permissions.js';
export const loginBodySchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Informe a senha').max(200),
});
export const refreshBodySchema = z.object({
    refreshToken: z.string().min(1),
});
export const sessionUserSchema = z.object({
    id: idSchema,
    name: z.string(),
    email: z.string(),
    isActive: z.boolean(),
    companyId: idSchema,
    companyName: z.string(),
    unitId: idSchema.nullable(),
    unitName: z.string().nullable(),
    profiles: z.array(z.object({ id: idSchema, slug: z.string(), name: z.string() })),
    fullAccess: z.boolean(),
    permissions: z.array(permissionCodeSchema),
});
export const authTokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    /** Segundos até o access token expirar — o admin agenda o refresh com isso. */
    expiresIn: z.number().int(),
});
export const loginResponseSchema = z.object({
    tokens: authTokensSchema,
    user: sessionUserSchema,
});
export const permissionsResponseSchema = z.object({
    fullAccess: z.boolean(),
    permissions: z.array(permissionCodeSchema),
});
export const changePasswordBodySchema = z
    .object({
    currentPassword: z.string().min(1, 'Informe a senha atual'),
    newPassword: z
        .string()
        .min(10, 'A nova senha precisa de pelo menos 10 caracteres')
        .max(200)
        .regex(/[a-zA-Z]/, 'A senha precisa conter letras')
        .regex(/\d/, 'A senha precisa conter números'),
    confirmPassword: z.string(),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'A confirmação não confere com a nova senha',
    path: ['confirmPassword'],
})
    .refine((v) => v.newPassword !== v.currentPassword, {
    message: 'A nova senha deve ser diferente da atual',
    path: ['newPassword'],
});
//# sourceMappingURL=auth.js.map